import React, { useState } from 'react';
import { GiBookPile } from 'react-icons/gi';
import './SeriesCard.css';
import { Link } from 'react-router-dom';
import Title from '../Title';
import colors from '../../assets/colors';
const SeriesCard = (props) => {
    const { series } = props;
    const [hovered, setHovered] = useState(false);
    return (React.createElement(Link, { to: series.stub, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) },
        React.createElement("div", { className: `series-tile ${hovered ? 'hovered' : ''}`, style: {
                backgroundImage: `url(${series.image})`
            } },
            React.createElement("div", { className: 'content-container' },
                React.createElement(Title, { title: series.title, subtitle: 'Series' }),
                React.createElement("div", { className: 'details book-count' },
                    React.createElement(GiBookPile, { size: 16, color: colors.primary.lightGray }),
                    React.createElement("p", null,
                        series.installments.length,
                        " Title",
                        series.installments.length > 1 ? 's' : ''))),
            React.createElement("div", { className: 'overlay' }))));
};
export default SeriesCard;
